import Image from "next/image";

export default function Sparkle(props: { size?: number; className?: string }) {
  const { size = 16, className } = props;

  return (
    <Image
      src="/images/cv/cv-enhance-sparkle.svg"
      alt="Sparkle"
      width={size}
      height={size}
      className={`size-5 md:size-${size}px ${className}`}
    />
  );
}
